<div class="header">
  <div class="mat-headline-4 mat-header-bottom-pad">{{ title }}</div>
  <div><ng-content select="[actions]" /></div>
</div>
